import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { TipProgramActiveService } from '../tip-program-active.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map, of } from 'rxjs';
import { helper } from 'src/environments/helper';
import { TipProgramActive } from '../tip-program-active.interface';
import { GhiseuModuleService } from '../../ghiseu-module/ghiseu-module.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { ServiciiService } from '../../servicii/servicii.service';
import { TipProgramService } from '../../tip-program/tip-program.service';
import { dateRangeValidator } from 'src/app/utils/common/validators/date-period';

@Component({
    selector: 'app-add-tip-program-active',
    templateUrl: './add-tip-program-active.component.html',
    styleUrls: ['./add-tip-program-active.component.scss']
})
export class AddTipProgramActiveComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    locatii!: any[];

    module!: any[];
    servicii!: any[];
    tipuriProgram!: any[];

    durataOptions: { name: string; value: number }[] = [
        { name: '-- Alegeți --', value: -1 },
        { name: '5 minute', value: 5 },
        { name: '10 minute', value: 10 },
        { name: '15 minute', value: 15 },
        { name: '20 minute', value: 20 },
        { name: '25 minute', value: 25 },
        { name: '30 minute', value: 30 },
        { name: '35 minute', value: 35 },
        { name: '40 minute', value: 40 },
        { name: '45 minute', value: 45 },
        { name: '50 minute', value: 50 },
        { name: '55 minute', value: 55 },
        { name: '60 minute', value: 60 },
    ]

    form: FormGroup = new FormGroup({
        id_modul: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_locatie: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_program_type: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        durata_interval_blocare: new FormControl(-1, [Validators.required, Validators.min(0)]),
        durata_programare: new FormControl(-1, [Validators.required, Validators.min(0)]),
        max_date_available: new FormControl('', [Validators.required]),
        min_date_available: new FormControl('', [Validators.required]),
    }, { validators: dateRangeValidator('min_date_available', 'max_date_available') });

    constructor(
        private dialogRef: MatDialogRef<AddTipProgramActiveComponent>,
        private tipProgramActiveService: TipProgramActiveService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private ghiseuModuleService: GhiseuModuleService,
        private locatiiService: LocatiiService,
        private serviciiService: ServiciiService,
        private tipProgramService: TipProgramService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadModule();
        this.loadLocatii();
        this.loadServicii();
        this.loadTipuriProgram();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.tipProgramActiveService.setToken(token);
        });
    }

    loadModule() {
        this.isLoading = true;
        this.ghiseuModuleService.getModule().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.module = res;
            },
            error: (err) => {
                console.error('Error in get ghiseu module: ', err);
            }
        })
    }

    onModulChange(modulId: number): void {
        this.form.controls['id_locatie'].patchValue("-1");

        if (modulId == -1) {
            this.locatii = [];
            return;
        }

        if (modulId) {
            this.loadLocatii(modulId);
        }
    }

    loadLocatii(modulId?: number) {
        this.isLoading = true;
        let locatiiObservable$ = modulId
            ? this.locatiiService.getLocatiiByModulId(modulId)
            : of([]);

        locatiiObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isLoading = false;
            })
        ).subscribe({
            next: (locatii) => {
                this.locatii = [...locatii];
            },
            error: (err) => {
                console.log(err);
            }
        });
    }

    loadServicii() {
        this.isLoading = true;
        this.serviciiService.getServicii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.servicii = res;
            },
            error: (err) => {
                console.error('Error in get servicii: ', err);
            }
        })
    }

    loadTipuriProgram() {
        this.isLoading = true;
        this.tipProgramService.getTipuriProgram().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.tipuriProgram = res;
            },
            error: (err) => {
                console.error('Error in get tipuri program: ', err);
            }
        })
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_locatie, id_serviciu, id_program_type, durata_interval_blocare, durata_programare, min_date_available, max_date_available } = this.form.value as any;

        const newTipProgramActive: TipProgramActive = {
            id_modul,
            id_locatie,
            id_serviciu,
            id_program_type,
            durata_interval_blocare,
            durata_programare,
            max_date_available: max_date_available ? this.formatDate(max_date_available) : '',
            min_date_available: min_date_available ? this.formatDate(min_date_available) : '',
        };

        this.tipProgramActiveService
            .addTipProgramActive(newTipProgramActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
